import { Box, IconButton, Menu, MenuButton, MenuList } from "@chakra-ui/react"
import PropTypes from "prop-types"
import { useState } from "react"
import { useSetRecoilState } from "recoil"
import { activeArticleTableRowState } from "../../../../../../common/store/articleTableStore"
import { CMore } from "../../../../../shared/Icons"
import AccessoriesMenuItem from "./AccessoriesMenuItem"
import AddArticleMenuItem from "./AddArticleMenuItem"
import DownloadArticlePDFMenuItem from "./DownloadArticlePDFMenuItem"
import DownloadCadDrawingsMenuItem from "./DownloadCadDrawingsMenuItem"
import DownloadImagesMenuItem from "./DownloadImagesMenuItem"
import ModelViewer3dMenuItem from "./ModelViewer3dMenuItem"
import TenderTextMenuItem from "./TenderTexMenuItem"

const ThreeDotsMenu = ({
  options,
  articleCode,
  availableZipOptionsFormData,
  rowNumberVal,
  resetScroll,
  isArchived,
}) => {
  const [isModalOpenFromMenu, setIsModalOpenFromMenu] = useState(false)
  const setActiveArticleTableRowState = useSetRecoilState(activeArticleTableRowState)

  const handleOpen = () => {
    resetScroll(rowNumberVal)
    setActiveArticleTableRowState(rowNumberVal)
  }

  return (
    <Box position="absolute" right={0}>
      <Menu
        autoSelect={false}
        closeOnSelect={false}
        closeOnBlur={!isModalOpenFromMenu}
        gutter={0}
        flip={false}
        isLazy
        strategy="fixed"
        onOpen={() => {
          handleOpen()
        }}
        onClose={() => {
          setActiveArticleTableRowState(-1)
        }}
      >
        <MenuButton
          as={IconButton}
          aria-label="Open article table three dots menu"
          icon={<CMore boxSize="4" />}
          _expanded={{ bgColor: "gray.900", color: "white" }}
          variant="secondary"
          color="brand.500"
          minW="10"
          minH="10"
          ml="4"
          mr="2"
          mt="-0.5"
          justifySelf="end"
        />
        <MenuList boxShadow="md">
          {!isArchived && <AddArticleMenuItem articleCode={articleCode} />}
          <ModelViewer3dMenuItem articleCode={articleCode} setIsModalOpenFromMenu={setIsModalOpenFromMenu} />
          {!isArchived && <AccessoriesMenuItem articleCode={articleCode} accessories={options.accessories} />}
          <DownloadArticlePDFMenuItem articleCode={articleCode} isArchived={isArchived} />
          <DownloadCadDrawingsMenuItem
            availableZipOptionsFormData={availableZipOptionsFormData}
            zipCadDrawingsLink={options.zipCadDrawingsLink}
            setIsModalOpenFromMenu={setIsModalOpenFromMenu}
            isArchived={isArchived}
          />
          <DownloadImagesMenuItem zipPhotosDrawingsLink={options.zipPhotosDrawingsLink} isArchived={isArchived} />
          <TenderTextMenuItem tenderTextId={options.tenderTextId} setIsModalOpenFromMenu={setIsModalOpenFromMenu} />
        </MenuList>
      </Menu>
    </Box>
  )
}

export default ThreeDotsMenu

ThreeDotsMenu.propTypes = {
  options: PropTypes.shape({
    zipCadDrawingsLink: PropTypes.string,
    zipPhotosDrawingsLink: PropTypes.string,
    tenderTextId: PropTypes.string,
  }),
  articleCode: PropTypes.string,
  availableZipOptionsFormData: PropTypes.object,
  rowNumberVal: PropTypes.number,
  resetScroll: PropTypes.func,
  isArchived: PropTypes.bool,
}
